import { Template } from "@suse-o11y/template";

import type { MetricQuery } from "~/models/metric-query";

interface Spec {
	promql: Template<["${", "}"], null>;
	alias?: Template<["${", "}"], null>;
	minStep?: Template<["${", "}"], null>;
}

const DEFAULT = {
	promql: Template(""),
	alias: Template(""),
	minStep: Template(""),
} satisfies Spec;

function fromMetricQuery({ promql, label, step }: MetricQuery): Spec {
	return {
		promql: Template(promql),
		alias: label ?? DEFAULT.alias,
		minStep: step == null ? DEFAULT.minStep : Template(step.toString()),
	};
}

export type { Spec };
export { DEFAULT, fromMetricQuery };
